export default __webpack_public_path__ + "static/media/bg.c3f2878c.svg";